import { createAction } from 'redux-actions';

import { FETCH_NEWS_REQUEST, FETCH_NEWS_SUCCESS } from './constants';

export const fetchNews = createAction(
	FETCH_NEWS_REQUEST,
	(token: string) => ({ token }),
);

export const setNews = createAction(
	FETCH_NEWS_SUCCESS,
	(news: any) => news,
);
